import type { Deal } from '../types/deal'

export const DEFAULT_MESSAGE = 'Hi,\n\nPlease find the attached invoice.\n\nThanks,\nCalyx'

export function dealEmailFor(deal: Deal | null | undefined, companyName: string): string {
  if (!deal) return ''
  if (deal.customerEmail && deal.customerEmail.trim()) return deal.customerEmail.trim()
  const slug = (companyName || deal.companyId).toLowerCase().replace(/\s+/g, '')
  return `billing@${slug}.com`
}

export function dealCcFor(deal: Deal | null | undefined): string[] {
  if (!deal) return []
  const on = deal.ccExecOn ?? true
  if (!on) return []
  return deal.ccExecs ?? []
}

export function parseCcList(input: string): string[] {
  return input
    .split(/[,;\s]+/)
    .map((token) => token.trim())
    .filter(Boolean)
}

export function joinCcList(list: string[] | undefined | null): string {
  return (list ?? []).join(', ')
}
